// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\TopicCardTemplateAttachment\ApiTopicCardTemplateAttachment.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { TopicCardTemplate, TopicCardTemplateData, TopicCardTemplateOptions } from 'data/models/TopicCardTemplate';

// TopicCardTemplateAttachmentData is the class that TopicCardTemplateAttachment serializes to/from
export interface TopicCardTemplateAttachmentData {
    Id : number;
    Url : string | null;
	
    AttachmentUrl : string;
    Template : TopicCardTemplateData | null;
    TemplateId : number;
	
    DisplayOrder : number;
}

// TopicCardTemplateAttachmentOptions is the class which may be passed to the TopicCardTemplateAttachment constructor to define optional initial data values
export interface TopicCardTemplateAttachmentOptions {
    Id : number;
    Url? : string | null;
	
    AttachmentUrl? : string;
    Template? : TopicCardTemplateOptions | null;
    TemplateId? : number;
	
    DisplayOrder? : number;
}

export class TopicCardTemplateAttachment {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public AttachmentUrl : DataSignal<string>;
    public Template : DataSignal<TopicCardTemplate | null>;
    public TemplateId : DataSignal<number>;
	
    public DisplayOrder : DataSignal<number>;

    constructor();
    constructor(data : TopicCardTemplateAttachmentOptions);
    constructor(data: TopicCardTemplateAttachmentOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.AttachmentUrl = jsonableObservable(S.value<string>(data && data.AttachmentUrl !== undefined ? data.AttachmentUrl : ''));
        this.Template = S.value<TopicCardTemplate | null>(null);
        this.TemplateId = jsonableObservable(S.value<number>(data && data.TemplateId !== undefined ? data.TemplateId : 0));
	    
        this.DisplayOrder = jsonableObservable(S.value<number>(data && data.DisplayOrder !== undefined ? data.DisplayOrder : 0));
    }

    static key(obj : TopicCardTemplateAttachment) {
        return obj.Id();
    }
    
    static dataKey(obj : TopicCardTemplateAttachmentOptions) {
        return obj.Id;
    }

    static update(obj : TopicCardTemplateAttachment, data : TopicCardTemplateAttachmentOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.AttachmentUrl !== undefined) obj.AttachmentUrl(data.AttachmentUrl);
            if (data.TemplateId !== undefined) obj.TemplateId(data.TemplateId);
	        
            if (data.DisplayOrder !== undefined) obj.DisplayOrder(data.DisplayOrder);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/TopicCardTemplateAttachment.ts